import { TransportDetailLayout, TransportDetailMode } from './../../../../common/configuration/transport.configuration';
import { TransportDetailsLayoutService } from './../../../transport-details/transport-details-layout.service';
import { TransportDetailsLayoutConverter } from './../../../../common/components/tmp/transport-details-layout-converter.service';
import { DialogLayout } from './../../../../../app/shared/dialog-layout/dialog-layout';
import { RegisterLeaveComponent, RegisterLeaveDialogData } from './../../../visit-overview/dialog/register-leave/component/register-leave.component';
import { RegisterLeaveCombinedComponent, RegisterLeaveCombinedDialogData } from './../../../visit-overview/component/register-leave-combined/register-leave-combined.component';
import { TMCClientParameters } from './../../../../../tmc-common/tmc-client-parameters';
import { VisitService } from './../../../visit-overview/service/visit.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActionItem, ConfigurationService, HttpService } from '@sdbn/appclient';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AsyncSubject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Transport } from 'src/tmc-yard/common/model/transport.model';
import { interval } from 'rxjs';

@Component({
  selector: 'app-action-tablet-transport-item',
  templateUrl: './action-tablet-transport-item.component.html',
  styleUrls: ['./action-tablet-transport-item.component.scss']
})
export class ActionTabletTransportItemComponent implements OnInit, OnDestroy {

  TransportDetailMode = TransportDetailMode;

  @Input() actionItem: ActionItem;

  transports = new Array<Transport>();

  clientParameters = TMCClientParameters;

  layoutDefinition: TransportDetailLayout;

  timerSubscription: Subscription;

  constructor(
    public cps: ConfigurationService,
    private httpService: HttpService,
    private dialog: MatDialog,
    private visitService: VisitService,
    transportDetailsLayoutConverter: TransportDetailsLayoutConverter,
    private transportDetailsLayoutService: TransportDetailsLayoutService
  ) {

    this.layoutDefinition = transportDetailsLayoutConverter.convert(
      this.transportDetailsLayoutService.createStationAssignmentTransportDetailsGridLayout()
    );

  }

  ngOnInit(): void {

    this.loadProfiles();

    if (this.actionItem.refreshTimer > 0) {

      this.timerSubscription = interval(this.actionItem.refreshTimer*1000).subscribe(n => {
        this.loadProfiles();
      });
    }
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = null;
    }
  }

  handleClick(transport: Transport) {

    var data = JSON.parse(this.actionItem.data);

    /* entrance action */
    if (data.action === 'entrance') {
      this.visitService.openRegisterEntranceDialog(transport.id, () => { });
    }

    /* leave action */
    if (data.action === 'leave') {
      if (this.cps.isEnabled(this.clientParameters.FEATURES_COMBINED_LEAVE, false)) {
        const dialogData: RegisterLeaveCombinedDialogData = {
          transportId: transport.id,
          callback: () => {
            this.loadProfiles();
          }
        };

        this.dialog.open(RegisterLeaveCombinedComponent, {
          maxHeight: '95vh',
          data: dialogData,
          panelClass: DialogLayout.panelClass
        });
      } else {
        const dialogData: RegisterLeaveDialogData = {
          transportId: transport.id,
          callback: () => {
            this.loadProfiles();
          }
        };

        this.dialog.open(RegisterLeaveComponent, {
          maxHeight: '95vh',
          data: dialogData,
          panelClass: DialogLayout.panelClass
        });
      }
    }
  }

  private loadProfiles(): AsyncSubject<void> {

    var data = JSON.parse(this.actionItem.data);

    const subject = new AsyncSubject<void>();
    this.httpService.postWithContext<Array<Transport>>(environment.tmcBaseUrl + '/tmc-yard/control/actionTabletTransport/getAll', data.customFilterId).subscribe(response => {
      let transports = new Array<Transport>();
      for (const transport of response) {
        transports.push(new Transport(transport));
      }
      this.transports = transports;
      subject.next();
      subject.complete();
    }, error => {
      subject.error('');
    });
    return subject;
  }

}
